import * as React from 'react';

import {
  Lang,
  Breakpoint,

  useDimensions,

  TextBlock,
} from '@bluecurrent/web-component-lib';

import handleLocalUrlChange from '../../../../../functions/handleLocalUrlChange';
import handleHeadingPrioritization from '../../../../../functions/handleHeadingPrioritization';

import Setup from '../../../../../config/Setup.config';

export default function Content(props) {
  const { i18n } = Lang.useTranslation();
  const size = useDimensions();

  const lang = Setup.PSEUDO ? Setup.FALLBACK_LANG : i18n.language;

  return (
    <div
      style={{
        height: 'auto',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}
    >
      {
        (
          props.data.title !== undefined
          || props.data.text !== undefined
        ) && (
          <TextBlock
            title={{
              content: props.data.title !== undefined && (
                props.data.title[lang]
              ),
              portableText: props.data.title !== undefined,
              heading: handleHeadingPrioritization(props.params.index),
            }}
            text={{
              content: props.data.text !== undefined && (
                props.data.text[lang]
              ),
              portableText: props.data.text !== undefined,
            }}
            align={size.width < Breakpoint.sm ? props.data.align : 'left'}
            buttons={
              (props.data.buttons !== undefined)
              && props.data.buttons.map((item) => ({
                /* eslint-disable no-underscore-dangle */
                id: item._key,
                text: item.link.text === 'custom' ? item.link.custom_text[lang] : item.link.text[lang],
                colorScheme: item.colorscheme,
                onClick: () => window.open(handleLocalUrlChange(item.link.url), item.link.target),
              }))
            }
          />
        )
      }
    </div>
  );
}
